export const Footer = () => (
  <footer className="border-t border-white/10 mt-16 py-4 fixed bottom-0 left-0 right-0">
    <div className="container mx-auto px-6">
      <div className="text-center text-zinc-600 text-sm">
        © {new Date().getFullYear()} hakt0r
      </div>
    </div>
  </footer>
)
